export default __webpack_public_path__ + "static/9-20bd9ba9b67e7eed501187aefd6fcc95.png";